import { z } from "zod";
import { RoleSchema } from "./common.ts";

export const CreateUserSchema = z.object({
	username: z
		.string()
		.min(2, "Username must be at least 2 characters")
		.max(120, "Username too long"),
	password: z
		.string()
		.min(8, "Password must be at least 8 characters")
		.max(512, "Password too long"),
	role: RoleSchema,
});
export type CreateUserInput = z.infer<typeof CreateUserSchema>;

export const UpdateUserRoleSchema = z.object({
	role: RoleSchema,
});
export type UpdateUserRoleInput = z.infer<typeof UpdateUserRoleSchema>;
